module.exports = __webpack_public_path__ + "img/bg.46b4592b.png";